export interface FieldAnimalValue {
  value: string
}

interface FieldAnimalProps {
  [key: string]: FieldAnimalValue
}

export interface TypesProps {
  id: string
  value: string
}

export type DiagnosisTypesProps = TypesProps;

interface DiagnosisTypesOptionsProps {
  [key: string]: TypesProps
}

interface AnimalGenderProps {
  [key: string]: TypesProps
}

export const fieldAnimal: FieldAnimalProps = {
  NADA: {
    value: 'Nada'
  },
  ALGUMA: {
    value: 'Alguma'
  }
}

export const diagnosisTypes: DiagnosisTypesOptionsProps = {
  vazio: {
    id: 'vazio',
    value: 'Vazio'
  },
  prenha: {
    id: 'prenha',
    value: 'Prenha'
  }
}

export const animalGenderTypes: AnimalGenderProps = {
  macho: {
    id: 'M',
    value: 'Macho'
  },
  femea: {
    id: 'F',
    value: 'Fêmea'
  }
}

export const animalAgeFilters: Record<string, { id: string; value: string }> = {
  '<7': {
    id: '<7',
    value: 'Menor que 7 anos'
  },
  '<12': {
    id: '<12',
    value: 'Menor que 12 anos'
  },
  '<15': {
    id: '<15',
    value: 'Menor que 15 anos'
  },
  '<30': {
    id: '<30',
    value: 'Menor que 30 anos'
  },
  '>=30': {
    id: '>=30',
    value: 'Maior ou igual a 30 anos'
  }
}


export const fieldAnimalOptions = Object.keys(fieldAnimal).map((key: string) => fieldAnimal[key])
export const diagnosisOptions = Object.keys(diagnosisTypes).map((key: string) => diagnosisTypes[key])
export const animalGenderOptions = Object.keys(animalGenderTypes).map((key: string) => animalGenderTypes[key])
export const animalAgeFiltersOptions = Object.keys(animalAgeFilters).map((key: string) => animalAgeFilters[key])
